import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openLoginModal } from "../reduxtool/action";
// import logo from "../images/logoNew.png";
import logo from "../images/rama-hospital-logo.webp";
import { IoMdArrowDropdown } from "react-icons/io";

import { Link, useNavigate } from "react-router-dom";
import { TbLogout2 } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import { FaPhone } from "react-icons/fa6";
import { FiChevronDown, FiChevronUp, FiMenu, FiX } from "react-icons/fi";
import { setPatientDetails } from "../reduxtool/action";
import { decryptData } from "../Services/TabServices";
import profile from "../images/profile.svg";
import axios from "axios";

interface SpecialityItem {
  id: number;
  link: string;
  title: {
    rendered: string;
  };
}

const HOSPITALS = [
  {
    id: 6,
    name: "Lakhanpur",
    link: "https://ramahospital.com/rama-hospital-lakhanpur/",
  },
  {
    id: 5,
    name: "Mandhana",
    link: "https://ramahospital.com/rama-hospital-mandhana/",
  },
  {
    id: 4,
    name: "Baghpat",
    link: "https://ramahospital.com/rama-hospital-baghpat/",
  },
  {
    id: 3,
    name: "Hapur",
    link: "https://ramahospital.com/rama-hospital-hapur/",
  },
  {
    id: 2,
    name: "Mathura",
    link: "https://ramahospital.com/rama-hospital-mathura/",
  },
  {
    id: 1,
    name: "Noida",
    link: "https://ramahospital.com/rama-hospital-noida/",
  },
];

const UpperNavbar = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const token = sessionStorage.getItem("token");
  const storedUserId = sessionStorage.getItem("userId");
  const userId = storedUserId ? decryptData(storedUserId) : null;
  const patientProfile = useSelector((state: any) => state.userDetails);

  const [isProfileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [isSpecialityOpen, setSpecialityOpen] = useState(false);
  const [isHospitalOpen, setHospitalOpen] = useState(false);
  const [speciality, setSpeciality] = useState<SpecialityItem[]>([]);
  const [loading, setLoading] = useState(true);

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobileSpecialityOpen, setMobileSpecialityOpen] = useState(false);
  const [isMobileHospitalOpen, setMobileHospitalOpen] = useState(false);
  const [isPhoneOpen, setPhoneOpen] = useState(false);
  const [isMobilePhoneOpen, setMobilePhoneOpen] = useState(false);

  const mobileMenuRef = useRef<HTMLDivElement>(null);
const specialityRef = useRef<HTMLDivElement>(null);
const phoneTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

const handlePhoneEnter = () => {
  if (phoneTimerRef.current) clearTimeout(phoneTimerRef.current);
  setPhoneOpen(true);
};

const handlePhoneLeave = () => {
  phoneTimerRef.current = setTimeout(() => {
    setPhoneOpen(false);
  }, 150); // 150ms grace window — enough to travel to the dropdown
};
useEffect(() => {
  return () => {
    if (phoneTimerRef.current) clearTimeout(phoneTimerRef.current);
  };
}, []);
  // ── outside click closes mobile menu ──────────────────────────
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(e.target as Node)
      ) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ── auto-close on desktop resize ──────────────────────────────
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setMobileMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── fetch specialities ────────────────────────────────────────
  useEffect(() => {
    const fetchspecialization = async () => {
      try {
        const res = await axios.get(
          `https://ramahospital.com/wp-json/wp/v2/pages?parent=274&per_page=100&_fields=id,title,link`,
        );
        const sortedData = res.data.sort(
          (a: SpecialityItem, b: SpecialityItem) =>
            a.title.rendered.localeCompare(b.title.rendered),
        );
        setSpeciality(sortedData);
      } catch (err) {
        console.error("Error fetching specialities:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchspecialization();
  }, []);

  useEffect(() => {
    const isProfileEmpty =
      !patientProfile || Object.keys(patientProfile).length === 0;
    if (isProfileEmpty && token && userId) {
      dispatch(setPatientDetails(token, userId));
    }
  }, [dispatch, patientProfile, token, userId]);

  const handleLogOut = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("userId");
    setMobileMenuOpen(false);
    navigate("/doctors");
  };

  const closeMobileMenu = () => setMobileMenuOpen(false);

  useEffect(() => {
  const handleMouseLeave = (e: MouseEvent) => {
    if (
      specialityRef.current &&
      !specialityRef.current.contains(e.relatedTarget as Node)
    ) {
      setSpecialityOpen(false);
    }
  };

  const node = specialityRef.current;
  node?.addEventListener("mouseleave", handleMouseLeave);
  return () => node?.removeEventListener("mouseleave", handleMouseLeave);
}, []);

  return (
    // <nav className="sticky top-[33px] z-30 bg-white shadow-sm border-b border-gray-100">
    <nav className="sticky top-0 z-30 bg-white shadow-sm border-b border-gray-100 ">
      {/* ══════════════════════════════════════════
          DESKTOP LAYOUT  (lg and above)
      ══════════════════════════════════════════ */}

   <div className="hidden lg:flex items-center justify-between h-[70px] max-w-[1250px] mx-auto w-full px-6 gap-4">        {/* 1. Phone */}
     <div
  className="relative h-8"
  onMouseEnter={handlePhoneEnter}
  onMouseLeave={handlePhoneLeave}
>
  {/* Phone icon */}
  <a
    href="tel:+917302991952"
    className="w-7 h-7 rounded-full bg-[#009A85] flex items-center justify-center text-white hover:bg-[#007d6a] transition shrink-0"
  >
    <FaPhone size={15} />
  </a>

  {/* Dropdown — fixed, but stays open via timer */}
  <div
    className={`
      fixed left-0 top-[70px] w-full bg-[#009A85] z-[9999] py-4 px-6 shadow-md
      transition-all duration-300 ease-in-out origin-top
      ${
        isPhoneOpen
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 -translate-y-3 pointer-events-none"
      }
    `}
    onMouseEnter={handlePhoneEnter}  
    onMouseLeave={handlePhoneLeave}  
  >
    <div className="flex flex-wrap items-center justify-center gap-2 max-w-[1250px] mx-auto">
      {[
        { name: "Noida",     phone: "+91 9711789898" },
        { name: "Hapur",     phone: "+91 7065000999" },
        { name: "Baghpat",   phone: "+91 9520882969" },
        { name: "Mandhana",  phone: "+91 7310473105" },
        { name: "Lakhanpur", phone: "+91 7081570570" },
        { name: "Mathura",   phone: "+91 9520750520" },
      ].map((h) => (
        <a
          key={h.name}
          href={`tel:${h.phone.replace(/\s/g, "")}`}
          className="flex items-center gap-1.5 border border-white/60 rounded-full px-4 py-1 text-white text-[13px] hover:bg-white/20 transition whitespace-nowrap"
        >
          <span className="font-semibold">{h.name}:</span>
          <span className="font-normal">{h.phone}</span>
        </a>
      ))}
    </div>
  </div>
</div>

        {/* ─────────────────────────────────────────────────────────
            2. Our Hospitals
            FIX: onMouseEnter/Leave on PARENT div — no gap between
                 trigger and dropdown. Dropdown uses pt-3 inside so
                 the invisible padding bridges the cursor travel.
        ───────────────────────────────────────────────────────── */}
        <div
          className="relative cursor-pointer flex items-center gap-1 text-[#1a1a2e] hover:text-[#009A85] transition"
          onMouseEnter={() => setHospitalOpen(true)}
          onMouseLeave={() => setHospitalOpen(false)}
        >
          {/* visible label */}
          <span className="flex text-[#3C3C3C]  items-center gap-1 text-[16px] font-medium">
            Our Hospitals <IoMdArrowDropdown size={14} />
          </span>

          {/* dropdown — sits flush under label via top-full; pt-3 bridges gap */}
          {isHospitalOpen && (
            <div className="absolute top-full left-0 pt-3 w-48 z-[9999]">
              <div className="bg-white shadow-2xl rounded-md border border-gray-100 py-2">
                {HOSPITALS.map((hospital) => (
                  <a
                    key={hospital.id}
                    href={hospital.link}
                    target=""
                    rel="noopener noreferrer"
                    onClick={() => setHospitalOpen(false)}
                    className="flex items-center gap-2 px-6 py-2.5 text-[15px] font-medium text-[#3C3C3C]  hover:bg-[#f0faf8] hover:text-[#009A85] transition"
                  >
                    {hospital.name}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ─────────────────────────────────────────────────────────
            3. Specialities — mega menu
            FIX: onMouseEnter/Leave on PARENT div (not inner span).
                 Mega panel uses a wrapper div with pt-3 so there is
                 zero gap between trigger text and the white panel.
                 The panel itself is position:fixed so it never
                 affects layout — no layout shift / shrinking.
        ───────────────────────────────────────────────────────── */}

<div
  className="cursor-pointer flex items-center gap-1 hover:text-[#009A85] transition"
  onMouseEnter={() => setSpecialityOpen(true)}
  onMouseLeave={() => setSpecialityOpen(false)}
>
  <span className="flex items-center gap-1 text-[#3C3C3C] text-[16px] py-6 font-medium">
    Specialities <IoMdArrowDropdown size={15}/>
  </span>

  {isSpecialityOpen && (
    <div className="absolute top-full left-1/2 -translate-x-1/2  w-[1000px] z-[9999]" 
    
    >
      <div className="rounded-md bg-white shadow-2xl border border-gray-100 px-5 py-6">
        {loading ? (
          <div className="grid grid-cols-4 gap-3">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="h-8 bg-gray-100 rounded animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {speciality.map((item) => (
              <a
                key={item.id}
                href={item.link}
                rel="noopener noreferrer"
                onClick={() => setSpecialityOpen(false)}
                className="font-medium text-[15px] text-[#3C3C3C] py-[6px] px-2 rounded hover:bg-[#f0faf8] hover:text-[#009A85] transition flex items-center gap-2"
              >
                <span>{item.title.rendered}</span>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  )}
</div>









        {/* 4. Logo — center */}
        <Link
          to="https://ramahospital.com/"
          className="shrink-0"
          onClick={() =>
            window.dispatchEvent(new CustomEvent("resetDoctorsFilters"))
          }
        >
          <img
            src={logo}
            alt="Rama Hospital Logo"
            className="h-[50px] w-auto object-contain"
          />
        </Link>

        {/* 5. Discover RAMA */}
        <Link
          to="https://ramahospital.com/about-us/"
          className="text-[16px] font-medium text-[#3C3C3C]  hover:text-[#009A85] transition whitespace-nowrap"
        >
          Discover RAMA
        </Link>

        {/* 6. Contact Us */}
        <Link
          to="/"
          className="text-[16px] font-medium text-[#3C3C3C]  hover:text-[#009A85] transition whitespace-nowrap"
        >
        Find A Doctor
        </Link>
<div></div>
        {/* 7. Auth */}
        {/* {token ? (
          <div
            className="relative flex items-center"
            onMouseEnter={() => setProfileDropdownOpen(true)}
            onMouseLeave={() => setProfileDropdownOpen(false)}
          >
            <button className="flex items-center">
              {patientProfile?.patientImages?.length > 0 &&
              patientProfile.patientImages[0]?.imagePath ? (
                <img
                  src={`${process.env.REACT_APP_BASE_URL}${patientProfile.patientImages[0].imagePath}`}
                  alt="Profile"
                  className="rounded-full w-9 h-9 border border-gray-300 object-cover"
                />
              ) : (
                <img
                  src={profile}
                  alt="Profile"
                  className="rounded-full w-9 h-9 border border-gray-300"
                />
              )}
            </button>

            {isProfileDropdownOpen && (
              <div className="absolute top-[36px] right-0 shadow-lg rounded-md py-1 w-48 z-[9999] bg-[#184A84]">
                <Link
                  to="/profile"
                  onClick={() => setProfileDropdownOpen(false)}
                >
                  <div className="flex items-center gap-2 px-4 border-b border-blue-400 text-white py-2 hover:bg-gray-100 hover:text-[#184A84] text-[15px] font-semibold">
                    <CgProfile /> My Profile
                  </div>
                </Link>
                <Link
                  to="/myappointments"
                  onClick={() => setProfileDropdownOpen(false)}
                >
                  <div className="flex items-center gap-2 px-4 border-b border-blue-400 text-white py-2 hover:bg-gray-100 hover:text-[#184A84] text-[15px] font-semibold">
                    <TbLogout2 /> My Appointments
                  </div>
                </Link>
                <div
                  onClick={handleLogOut}
                  className="flex items-center gap-2 px-4 text-white py-2 hover:bg-gray-100 hover:text-[#184A84] text-[15px] cursor-pointer font-semibold"
                >
                  <TbLogout2 /> Logout
                </div>
              </div>
            )}
          </div>
        ) : (
          <button
            onClick={() => dispatch(openLoginModal())}
            className="bg-gradient-to-r from-[#184A84] to-[#009A85] text-white text-[13px] py-2 px-4 rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#009A85] whitespace-nowrap transition shrink-0"
            aria-label="Login"
          >
            Login / SignUp
          </button>
        )} */}
      </div>

      {/* ══════════════════════════════════════════
          MOBILE / TABLET LAYOUT  (below lg)
      ══════════════════════════════════════════ */}
      <div
        className="flex lg:hidden items-center justify-between px-4 h-[8vh] w-full relative text-[#3C3C3C] "
        ref={mobileMenuRef}
      >
        {/* Logo — left */}
        <Link
          to="https://ramahospital.com/"
          className="shrink-0"
          onClick={() => {
            window.dispatchEvent(new CustomEvent("resetDoctorsFilters"));
            closeMobileMenu();
          }}
        >
          <img
            src={logo}
            alt="Rama Hospital Logo"
            className="h-[40px] w-auto object-contain"
          />
        </Link>

        {/* Right side: Login/Profile + Hamburger */}
        {/* <div className="flex items-center gap-2">
          {token ? (
            <div className="relative flex items-center">
              <button
                className="flex items-center"
                onClick={() => setProfileDropdownOpen((prev) => !prev)}
              >
                {patientProfile?.patientImages?.length > 0 &&
                patientProfile.patientImages[0]?.imagePath ? (
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}${patientProfile.patientImages[0].imagePath}`}
                    alt="Profile"
                    className="rounded-full w-8 h-8 border border-gray-300 object-cover"
                  />
                ) : (
                  <img
                    src={profile}
                    alt="Profile"
                    className="rounded-full w-8 h-8 border border-gray-300"
                  />
                )}
              </button>

              {isProfileDropdownOpen && (
                <div className="absolute top-[36px] right-0 shadow-lg rounded-md py-1 w-48 z-[9999] bg-[#184A84]">
                  <Link
                    to="/profile"
                    onClick={() => {
                      setProfileDropdownOpen(false);
                      closeMobileMenu();
                    }}
                  >
                    <div className="flex items-center gap-2 px-4 border-b border-blue-400 text-white py-2 hover:bg-gray-100 hover:text-[#184A84] text-[15px] font-semibold">
                      <CgProfile /> My Profile
                    </div>
                  </Link>
                  <Link
                    to="/myappointments"
                    onClick={() => {
                      setProfileDropdownOpen(false);
                      closeMobileMenu();
                    }}
                  >
                    <div className="flex items-center gap-2 px-4 border-b border-blue-400 text-white py-2 hover:bg-gray-100 hover:text-[#184A84] text-[15px] font-semibold">
                      <TbLogout2 /> My Appointments
                    </div>
                  </Link>
                  <div
                    onClick={handleLogOut}
                    className="flex items-center gap-2 px-4 text-white py-2 hover:bg-gray-100 hover:text-[#184A84] text-[15px] cursor-pointer font-semibold"
                  >
                    <TbLogout2 /> Logout
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button
              onClick={() => {
                dispatch(openLoginModal());
                closeMobileMenu();
              }}
              className="bg-gradient-to-r from-[#184A84] to-[#009A85] text-white text-[12px] py-1.5 px-3 rounded-lg hover:opacity-90 transition whitespace-nowrap"
              aria-label="Login"
            >
              Login / SignUp
            </button>
          )}

         
          <button
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            className="w-9 h-9 flex items-center justify-center rounded-md text-[#1a1a2e] hover:bg-gray-100 transition"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </div> */}

      
        {isMobileMenuOpen && (
          <div className="absolute top-full left-0 w-full bg-white shadow-xl border-t border-gray-100 z-[9999] py-2 max-h-[80vh] overflow-y-auto">
      
            <div className="border-b border-gray-100">
              <button
                onClick={() => setMobileHospitalOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-5 py-3 text-[14px] font-medium text-[#3C3C3C] hover:bg-[#f0faf8] hover:text-[#009A85]"
              >
                Our Hospitals
                {isMobileHospitalOpen ? (
                  <FiChevronUp size={16} />
                ) : (
                  <FiChevronDown size={16} />
                )}
              </button>
              {isMobileHospitalOpen && (
                <div className="bg-gray-50 px-4 pb-3 pt-1 flex flex-col gap-1">
                  {HOSPITALS.map((hospital) => (
                    <a
                      key={hospital.id}
                      href={hospital.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeMobileMenu}
                      className="flex items-center gap-2 text-[13px] font-medium text-[#3C3C3C] py-2 px-4 rounded hover:bg-white hover:text-[#009A85] transition"
                    >
                      {hospital.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* Specialities accordion */}
            <div className="border-b border-gray-100">
              <button
                onClick={() => setMobileSpecialityOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-5 py-3 text-[15px] font-medium text-[#3C3C3C] hover:bg-[#f0faf8] hover:text-[#009A85]"
              >
                Specialities
                {isMobileSpecialityOpen ? (
                  <FiChevronUp size={16} />
                ) : (
                  <FiChevronDown size={16} />
                )}
              </button>
              {isMobileSpecialityOpen && (
                <div className="bg-gray-50 px-4 pb-3">
                  {loading ? (
                    <div className="grid grid-cols-2 gap-2 py-2">
                      {Array.from({ length: 6 }).map((_, i) => (
                        <div
                          key={i}
                          className="h-7 bg-gray-200 rounded animate-pulse"
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="grid grid-cols-2 gap-1 pt-2">
                      {speciality.map((item) => (
                        <a
                          key={item.id}
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={closeMobileMenu}
                          className="text-[13px] font-medium text-[#3C3C3C] py-2 px-4 rounded hover:bg-white hover:text-[#009A85] transition"
                        >
                          {item.title.rendered}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Discover RAMA */}
            <Link
              to="https://ramahospital.com/about-us/"
              onClick={closeMobileMenu}
              className="flex items-center px-5 py-3 text-[15px] font-medium text-[#3C3C3C] hover:bg-[#f0faf8] hover:text-[#009A85] border-b border-gray-100"
            >
              Discover RAMA
            </Link>

            {/* Contact Us */}
            <Link
              to="/"
              onClick={closeMobileMenu}
              className="flex items-center px-5 py-3 text-[15px] font-medium text-[#3C3C3C] hover:bg-[#f0faf8] hover:text-[#009A85] border-b border-gray-100"
            >
             Find A Doctor
            </Link>

            {/* Phone */}
            <div className="border-b border-gray-100">
              <button
                onClick={() => setMobilePhoneOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-5 py-3 text-[14px] font-medium text-[#3C3C3C] hover:bg-[#f0faf8] hover:text-[#009A85]"
              >
                <span className="flex items-center gap-2">
                  <FaPhone size={13} className="text-[#009A85]" />
                  Contact Numbers
                </span>
                {isMobilePhoneOpen ? (
                  <FiChevronUp size={16} />
                ) : (
                  <FiChevronDown size={16} />
                )}
              </button>

              {isMobilePhoneOpen && (
                <div className="bg-gray-50 px-4 pb-3 pt-1 flex flex-col gap-1">
                  {[
                    { name: "Noida", phone: "+91 9711789898" },
                    { name: "Hapur", phone: "+91 7065000999" },
                    { name: "Baghpat", phone: "+91 9520882969" },
                    { name: "Mandhana", phone: "+91 7310473105" },
                    { name: "Lakhanpur", phone: "+91 7081570570" },
                    { name: "Mathura", phone: "+91 9520750520" },
                  ].map((h) => (
                    <a
                      key={h.name}
                      href={`tel:${h.phone.replace(/\s/g, "")}`}
                      onClick={closeMobileMenu}
                      className="flex items-center justify-between text-[13px] font-medium text-[#3C3C3C] py-2 px-4 rounded hover:bg-white hover:text-[#009A85] transition"
                    >
                      <span className="font-semibold">{h.name}</span>
                      <span className="text-[#009A85] font-medium">
                        {h.phone}
                      </span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default UpperNavbar;
